import React from "react";
import "./Banner.scss";

const Banner = ({ className, bannerImage, bannerTitle, bannerDescription }) => {
  return (
    <div className={`banner__main ${className ? className : ""}`}>
      <div i2c-container="container xl">
        <div className={"banner__grid"} i2c-grid="grid vertical-center">
          <div className={"banner__grid_content"} i2c-grid="8">
            <h1 className="banner__title">{bannerTitle}</h1>
            <p className="banner__description">{bannerDescription}</p>
          </div>
          <div className={"banner__grid_img"} i2c-grid="4">
            <img src={bannerImage} className="banner__image" alt="banner" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
